"use strict";

define('main',['require','exports','module','backbone','marionette','appkit/app','moment','./config','./config/routes','./config/model','./config/controller','./config/service','./config/moment','./config/validation','./config/error','./model/setting','./model/user.setting','./model/authority','./model/product','./model/heartbeat','./layout/main.layout','./layout/overlay.layout','uikit/collections/container','./libs/pendo.initializer','handlebars','./libs/storage.helper','langs','matchmedia','!domReady','./libs/ie9.fix'],function (require, exports, module) {
  var Backbone = require('backbone'),
    Mn = require('marionette'),
    App = require('appkit/app'),
    moment = require('moment'),
    config = require('./config'),
    RoutesConfigurator = require('./config/routes'),
    ModelConfigurator = require('./config/model'),
    ControllerConfigurator = require('./config/controller'),
    ServiceConfigurator = require('./config/service'),
    MomentConfigurator = require('./config/moment'),
    ValidationConfigurator = require('./config/validation'),
    ErrorConfigurator = require('./config/error'),
    Setting = require('./model/setting'),
    UserSetting = require('./model/user.setting'),
    Authority = require('./model/authority'),
    Product = require('./model/product'),
    Heartbeat = require('./model/heartbeat'),
    MainLayout = require('./layout/main.layout'),
    OverlayLayout = require('./layout/overlay.layout'),
    Container = require('uikit/collections/container'),
    PendoInitializer = require('./libs/pendo.initializer'),
    _handlebars = require('handlebars'),
    StorageHelper = require('./libs/storage.helper'),
    Langs = require('langs');
  require('matchmedia');
  require('!domReady');
  require('./libs/ie9.fix');
  var History = Backbone.history;
  History.checkUrl = function (e) {
    var current = History.getFragment();
    var legacyMainContentNode = document.getElementById('content');
    var mainContentNode = document.getElementById('irb-content');
    if (current === 'irb-content') {
      mainContentNode = legacyMainContentNode.childNodes.length > 0 ? legacyMainContentNode : mainContentNode;
      History.location.hash = History.fragment;
      current = History.fragment;
      mainContentNode.focus();
    }
    if (current === History.fragment && History.iframe) {
      current = History.getFragment(History.getHash(History.iframe));
    }
    if (current === History.fragment) return false;
    if (History.iframe) history.navigate(current);
    History.loadUrl();
  };
  if (window.__agent) {
    window.__agent.start(Backbone, Mn);
    window.__agent.disableAnalytics = true;
  }
  window.Handlebars = _.extend({}, Handlebars, _handlebars);
  var app = new App({
      name: config.APP_NAME,
      legacyName: config.APP_LEGACY_NAME
    }),
    layout = new MainLayout({
      app: app
    });
  document.querySelector('html').setAttribute('lang', navigator.language);
  app.registerSingleton('layout', layout);
  app.addConfigurator(ErrorConfigurator).addConfigurator(ValidationConfigurator).addConfigurator(RoutesConfigurator).addConfigurator(ModelConfigurator).addConfigurator(ServiceConfigurator).addConfigurator(ControllerConfigurator, [layout]).addConfigurator(MomentConfigurator);
  app.navigate = function (url, options) {
    if (config.usePushState && String(url).indexOf(config.staticRoot) === 0) {
      url = url.slice(config.staticRoot.length);
    }
    return Backbone.history.navigate(url, options);
  };
  app.config = config;
  app.phrase = Langs.phrase;
  app.p = app.phrase;
  app.storage = new StorageHelper().load();
  app.layout = layout;
  app.overlay = new OverlayLayout();
  app.settings = Setting.all([config.IRB_HAS_ORG_APPROVERS_NAME, config.IRB_CITI_ENABLED_NAME, config.IRB_TIMEZONE]);
  app.userSettings = UserSetting.all(app.name);
  app.authorities = Authority.createCollection();
  app.products = Product.all();
  app.heartbeat = new Heartbeat();
  Object.defineProperty(app, 'title', {
    set: function set(value) {
      app.channel.trigger('change:menuTitle', value);
      return value;
    },
    get: function get() {
      return app.request('menuTitle');
    }
  });
  app.settings.on('sync', function (model) {
    if (model.id === config.IRB_TIMEZONE) {
      moment.tz.setDefault(model.get('value'));
    }
  });
  app.userSettings.once('sync', function () {
    app.channel.trigger('user:settings', app.userSettings);
  });
  app.products.once('sync', function () {
    app.channel.trigger('user:products', app.products);
  });
  app.channel.once('app:start', function () {
    var container = new Container();
    container.add(app.request('top:menu'));
    container.add(app.request('product:menu'));
    layout.header.show(container);
    layout.overlay.show(app.overlay.render());
    var instantNotifications = app.request('build:instantNotifications');
    app.instantNotifications = instantNotifications.collection;
    legacyLayout.notifications.show(instantNotifications);
  });
  app.channel.once('authenticated', function (user) {
    app.user = user;
    app.heartbeat.start();
    app.authorities.set(user.authorities);
    Promise.join(app.products.fetch(), app.settings.fetch(), app.userSettings.fetch()).then(function () {
      app.channel.trigger('settings:fetched');
      app.globalMessages = app.service('notification').requestGlobalMessages();
      return app.globalMessages.fetch();
    })["finally"](function () {
      Backbone.history.start({
        pushState: !!window.USE_PUSHSTATE,
        root: window.STATIC_ROOT || '/'
      });
      PendoInitializer.initialize(app.user);
    });
  });
  app.start();
  window.app = app;
});

